import { BusinessTypeEnum, BusinessTypeLabel } from "@/enum/BusinessTypeEnum.ts";

export class InspectionListItem {
    /**
     * 정기 점검 아이디
     */
    readonly inspectionOutlineId: bigint;
    /**
     * 점검일
     */
    readonly inspectDate: string;
    /**
     * 충전소 아이디
     */
    readonly stationId: string;
    /**
     * 충전소명
     */
    readonly stationName: string;
    /**
     * 담당자 이름
     */
    readonly inspectorName: string;
    /**
     * 저장 여부
     */
    readonly isCompleted: boolean;
    /**
     * 정합성 여부
     */
    readonly isNotCorrect: boolean;
    /**
     * 사업명
     * */
    readonly businessName: BusinessTypeEnum;
    /**
     * 완속 여부
     */
    readonly isSlowCharger: boolean;

    get businessNameLabel(): string {
        return BusinessTypeLabel[this.businessName];
    }

    get chargerTypeLabel(): string {
        return this.isSlowCharger ? "완속" : "급속";
    }

    get completedLabel(): string {
        return this.isCompleted ? "저장 완료" : "임시 저장";
    }

    get correctLabel(): string {
        return this.isNotCorrect ? "부정합" : "정합";
    }

    get uri(): string {
        return `/inspections/${this.isSlowCharger ? "slow" : "rapid"}/${this.inspectionOutlineId}`;
    }
}